import React from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavItem,
  NavLink
} from "shards-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faUserSlash } from '@fortawesome/free-solid-svg-icons';

// Function to get user initials
const getInitials = (name) => {
  if (!name) return '?';
  
  const names = name.split(' ');
  if (names.length === 1) return names[0].charAt(0).toUpperCase();
  
  return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
};

export default class UserActions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };
    this.toggleUserActions = this.toggleUserActions.bind(this);
  }

  toggleUserActions() {
    this.setState({
      visible: !this.state.visible
    });
  }

  async stopImpersonate() {
    await this.props.stopImpersonate();
  }

  async handleSignOut() {
    // If user is currently impersonating, stop impersonation first
    if (this.props.impersonated) {
      await this.stopImpersonate();
    }
    // Then proceed with sign out
    window.location.href = "/login";
  }

  render() {
    const userName = this.props.user?.name || '?';
    return (
      <Dropdown open={this.state.visible} toggle={this.toggleUserActions} className="no-animation">
        <DropdownToggle nav caret className="text-nowrap px-3" style={{cursor: 'pointer'}}>
          <div 
            className="user-avatar rounded-circle mr-2" 
            style={{
              height: 40, 
              width: 40, 
              backgroundColor: '#21AA73', // EnforcePlus green
              color: '#fff',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '16px',
              fontWeight: '500'
            }}
          >
            {getInitials(userName)}
          </div>
          <span className="d-none d-md-inline-block">{this.props.impersonated ? `${this.props.impersonatedUser?.name} as ` : ''}{userName}</span>
        </DropdownToggle>
        <DropdownMenu right className="dropdown-menu-small" style={{
          border: '1px solid #eaedf3',
          borderRadius: '6px',
          boxShadow: '0 3px 12px rgba(0,0,0,0.08)',
          marginTop: '8px',
          padding: '8px 0',
          minWidth: '200px',
          zIndex: 1000,
          backgroundColor: '#fff'
        }}>
          {this.props.impersonated && this.props.impersonatedUser && (
            <DropdownItem style={{
              color: '#E6492E',
              padding: '10px 16px',
              fontSize: '13px',
              transition: 'background-color 0.2s ease',
            }} className="dropdown-item-hover" onClick={() => this.stopImpersonate()}>
              <FontAwesomeIcon icon={faUserSlash} className="mr-2" />
              Stop impersonating
            </DropdownItem>
          )}
          <DropdownItem style={{
            color: '#495057',
            padding: '10px 16px',
            fontSize: '13px',
            transition: 'background-color 0.2s ease',
          }} className="dropdown-item-hover" onClick={() => this.handleSignOut()}>
            <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
            Sign out
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  }
}
